import React from "react";
import PageSection from "./PageSection";

import {
  FaFacebook,
  FaApple,
  FaSnapchatGhost,
  FaAmazon,
  FaGoogle,
} from "react-icons/fa";

const DevApi = () => {
  const facts = [
    {
      id: 1,
      title: "$159M",
      subtitle:
        "Valuation is a quantitative process of determining the fair value of an asset or a firm.",
    },
    {
      id: 2,
      title: "69%",
      subtitle:
        "In general, a company can be valued on its own on an absolute basis",
    },
    {
      id: 3,
      title: "Since 2003",
      subtitle: "MAKING THE WORLD A BETTER PLACE SINCE 2003",
    },
    {
      id: 4,
      title: "Power Of Our",
      subtitle: "relative basis compared to other similar companies or assets.",
    },
  ];

  const companies = [
    {
      id: 1,
      icon: <FaGoogle size={25} />,
      title: "google",
    },
    {
      id: 2,
      icon: <FaFacebook size={25} />,
      title: "facebook",
    },
    {
      id: 3,
      icon: <FaAmazon size={25} />,
      title: "amazon",
    },
    {
      id: 4,
      icon: <FaApple size={25} />,
      title: "apple",
    },
    {
      id: 5,
      icon: <FaSnapchatGhost size={25} />,
      title: "snapchat",
    },
  ];

  return (
    <PageSection
      name="customers"
      title="Customers"
      subtitle={`A customer is a person or company that receives, consumes or buys a product or service and can choose between different goods and suppliers.`}
    >
      <>
        <div className="grid lg:grid-cols-4 text-left gap-8 mb-16">
          {facts.map(({ id, title, subtitle }) => (
            <div
              key={id}
              className="odd:bg-thBlue even:bg-thOrange text-black p-4 rounded-lg"
            >
              <h1 className="text-3xl font-bold mb-2">{title}</h1>
              <p>{subtitle}</p>
            </div>
          ))}
        </div>

        <div className="flex flex-col lg:flex-row items-center justify-around gap-6">
          {companies.map(({ id, icon, title }) => (
            <div
              className="flex items-center capitalize p-4 rounded-lg"
              key={id}
            >
              {icon}
              <p className="ml-2">{title}</p>
            </div>
          ))}
        </div>
      </>
    </PageSection>
  );
};

export default DevApi;
